  // Mobile drawer toggle — hamburger(s) open, backdrop/close/link tap closes.
  // Multiple triggers supported so the same drawer can be opened from the
  // top nav AND the sticky nav (which slides in after scrolling past hero).
  (function() {
    const triggers = document.querySelectorAll('.nav-mobile-trigger');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const backdrop = document.querySelector('[data-mobile-drawer-backdrop]');
    const closeBtn = document.querySelector('[data-mobile-drawer-close]');
    const links = document.querySelectorAll('[data-mobile-drawer-link]');
    if (!triggers.length || !drawer || !backdrop) return;

    const open = () => {
      drawer.hidden = false;
      backdrop.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add('open');
        backdrop.classList.add('open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-drawer-open');
    };
    const close = () => {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-drawer-open');
      setTimeout(() => {
        drawer.hidden = true;
        backdrop.hidden = true;
      }, 320);
    };

    triggers.forEach(t => t.addEventListener('click', open));
    backdrop.addEventListener('click', close);
    closeBtn && closeBtn.addEventListener('click', close);
    links.forEach(l => l.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });
  })();

  // FAQ toggle
  document.querySelectorAll('.faq-q').forEach(q => {
    q.setAttribute('role', 'button');
    q.setAttribute('tabindex', '0');
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
    q.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); q.click(); }
    });
  });

  // Footer accordion — on desktop force all <details> open and disable the
  // accordion behaviour. On mobile keep the first section open by default
  // and let the user tap to expand the rest. Re-syncs on viewport resize.
  (function() {
    const sections = document.querySelectorAll('.footer-section');
    if (!sections.length) return;
    const mql = window.matchMedia('(max-width: 768px)');
    function applyState() {
      const isMobile = mql.matches;
      sections.forEach((section, i) => {
        if (!isMobile) {
          section.setAttribute('open', '');
        } else if (i !== 0) {
          section.removeAttribute('open');
        }
      });
    }
    applyState();
    mql.addEventListener ? mql.addEventListener('change', applyState) : mql.addListener(applyState);
  })();

  // Doctor slider removed - the section is a single fixed Dr Tuckley quote now,
  // with no prev/next buttons, dots or swipe. The old IIFE called
  // .addEventListener directly on getElementById('doc-prev'), which would throw
  // on null once those buttons were deleted and halt every script after it.

  document.fonts.ready.then(function(){ document.documentElement.classList.add('fonts-ready'); });
  setTimeout(function(){ document.documentElement.classList.add('fonts-ready'); }, 2000);

// Buy Now — straight to checkout
document.querySelectorAll('.buy-now').forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var variantId = btn.dataset.variant;
    var sellingPlan = btn.dataset.sellingPlan;
    if (!variantId) return;

    if (sellingPlan) {
      window.location.href = '/cart/' + variantId + ':1?selling_plan=' + sellingPlan + '&checkout';
    } else {
      window.location.href = '/cart/' + variantId + ':1?checkout';
    }
  });
});


  // Sticky CTA — show once the reader is past the hero (its bottom crosses the
  // middle of the viewport). Anchored to the hero rather than the Doctors bar so
  // the trigger stays at the same early scroll depth even though the Doctors bar
  // now sits lower on the page (after the bridge). On mobile there's no hero
  // "Try Kept" button, so this persistent buy bar takes over from here.
  (function() {
    var sticky = document.getElementById('stickyCta');
    // .2 layout: fire off the bottom of the Shift section (the only
    // .r8-sec--tight-bottom). Falls back to the legacy .1 selectors.
    var trigger = document.querySelector('.r8-sec--tight-bottom')
               || document.querySelector('.hero')
               || document.querySelector('.dual-section')
               || document.querySelector('.ingredients-wrap');
    if (!sticky || !trigger) return;

    var shown = false;
    function checkScroll() {
      // Show the bar once the bottom of the Shift section has scrolled up past
      // the middle of the viewport — i.e. the reader has reached the end of it.
      var triggerBottom = trigger.getBoundingClientRect().bottom;
      var threshold = window.innerHeight * 0.5;
      if (triggerBottom < threshold && !shown) {
        sticky.classList.add('visible');
        shown = true;
      } else if (triggerBottom >= threshold && shown) {
        sticky.classList.remove('visible');
        shown = false;
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    // Run once on init so the CTA appears immediately if the page loaded
    // already scrolled past the trigger (refresh / scroll restoration).
    checkScroll();
  })();

  // Mobile scroll reveals (modelled on Shrine Pro theme approach)
  document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth > 768) return;


    // General section reveals
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var sectionObserver = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('visible');
          sectionObserver.unobserve(entries[i].target);
        }
      }
    }, { root: null, threshold: 0.15 });

    reveals.forEach(function(el) { sectionObserver.observe(el); });

    // Timeline reveal now handled by scroll handler in separate script block

  });

  // Nav scroll effect — slide the dark sticky nav DOWN from above once
  // the user has scrolled past the hero. The top transparent nav scrolls
  // away naturally with the page (it's position: absolute, not fixed).
  (function() {
    var stickyNav = document.querySelector('.nav-sticky');
    if (!stickyNav) return;
    // Desktop shows the purple nav as a constant header (see CSS); mobile keeps
    // the slide-in-on-scroll behaviour.
    var desktop = window.matchMedia('(min-width: 1041px)');
    var threshold = Math.min(900, window.innerHeight * 0.95);
    var lastY = window.scrollY;
    function onScroll() {
      var y = window.scrollY;
      if (desktop.matches) {
        // hide on scroll-down (past the header), show on scroll-up + near the top
        if (y <= 4) {
          stickyNav.classList.remove('nav-hidden');
          stickyNav.setAttribute('aria-hidden', 'false');
        } else if (y > lastY + 2 && y > 80) {
          stickyNav.classList.add('nav-hidden');
          stickyNav.setAttribute('aria-hidden', 'true');
        } else if (y < lastY - 2) {
          stickyNav.classList.remove('nav-hidden');
          stickyNav.setAttribute('aria-hidden', 'false');
        }
        syncBuyTop();
      } else {
        if (y > threshold) { stickyNav.classList.add('visible'); stickyNav.setAttribute('aria-hidden', 'false'); }
        else { stickyNav.classList.remove('visible'); stickyNav.setAttribute('aria-hidden', 'true'); }
      }
      lastY = y;
    }
    // Sync the sticky buy-panel's top gap to the nav: reserve room for the nav
    // when it's showing (scroll-up), collapse the gap when it's hidden (scroll-down)
    // so the panel isn't left with dead space up top and more of it stays visible.
    function syncBuyTop() {
      document.documentElement.style.setProperty(
        '--buy-top', stickyNav.classList.contains('nav-hidden') ? '20px' : '74px');
    }
    function applyMode() {
      stickyNav.classList.remove('nav-hidden');
      if (desktop.matches) {
        stickyNav.classList.remove('visible');
        stickyNav.setAttribute('aria-hidden', 'false');
        syncBuyTop();
      } else {
        document.documentElement.style.removeProperty('--buy-top');
        onScroll();
      }
      lastY = window.scrollY;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', applyMode); else desktop.addListener(applyMode);
    applyMode();
  })();

  // Anchor scroll — custom rAF smooth scroll + sustained snap-correction.
  //
  // The problem this solves: the page has 8 lazy-loaded images and a lazy
  // iframe between the top and the FAQ section. When the user clicks FAQ
  // from the top of the page, the smooth scroll heads toward FAQ's current
  // position. As we scroll past the lazy content, those images/iframe load
  // and push the FAQ section further down — so we land where FAQ USED to
  // be, not where it is now. Symptom: first click on FAQ lands too high
  // with the previous section showing; subsequent clicks land flush
  // (because the layout has stabilised).
  //
  // The fix has two parts:
  //   1. Custom rAF smooth scroll (immune to iOS Safari's bail-out quirks
  //      that cut native `behavior: 'smooth'` short on long distances).
  //   2. After the animation completes, run multiple snap-corrections over
  //      ~1.5s — re-measuring the target each time — so if lazy images
  //      finish loading after the animation, we adjust to the new position.
  //      Watcher self-cancels if the user starts manually scrolling.
  function smoothScrollToElement(targetElement, getOffset, duration) {
    duration = duration || 550;
    var startY = window.pageYOffset;
    var initialTargetY = targetElement.getBoundingClientRect().top + window.pageYOffset - getOffset();
    var distance = initialTargetY - startY;
    if (Math.abs(distance) < 2) return; // already there
    var startTime = performance.now();

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function snapToTarget() {
      var currentTargetY = targetElement.getBoundingClientRect().top + window.pageYOffset - getOffset();
      if (Math.abs(window.pageYOffset - currentTargetY) > 1) {
        window.scrollTo(0, currentTargetY);
      }
    }

    function startWatcher() {
      // Self-cancelling watcher — re-snaps to target for 1.5s after the
      // animation ends to catch lazy content loading. Stops the moment the
      // user touches the screen / scrolls manually so we don't fight them.
      var userScrolled = false;
      function onUserInteract() { userScrolled = true; cleanup(); }
      function cleanup() {
        window.removeEventListener('wheel', onUserInteract);
        window.removeEventListener('touchstart', onUserInteract);
      }
      window.addEventListener('wheel', onUserInteract, { once: true, passive: true });
      window.addEventListener('touchstart', onUserInteract, { once: true, passive: true });
      [0, 150, 350, 650, 1100, 1600].forEach(function(delay) {
        setTimeout(function() {
          if (userScrolled) return;
          snapToTarget();
        }, delay);
      });
      // Final cleanup after the last snap
      setTimeout(cleanup, 1700);
    }

    function step(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeInOutCubic(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        startWatcher();
      }
    }
    requestAnimationFrame(step);
  }

  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      smoothScrollToElement(target, function() {
        return parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    var slides = document.querySelectorAll('.carousel-slide');
    var dotsWrap = document.querySelector('.pagination-dots');
    var prevBtn = document.querySelector('.arrow-prev');
    var nextBtn = document.querySelector('.arrow-next');
    if (!slides.length || !dotsWrap || !prevBtn || !nextBtn) return;

    var currentSlide = 0;

    slides.forEach(function(_, i) {
      var dot = document.createElement('div');
      dot.className = 'pagination-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', function() { goToSlide(i); });
      dotsWrap.appendChild(dot);
    });

    function goToSlide(n) {
      slides[currentSlide].setAttribute('data-active', 'false');
      dotsWrap.children[currentSlide].classList.remove('active');
      currentSlide = (n + slides.length) % slides.length;
      slides[currentSlide].setAttribute('data-active', 'true');
      dotsWrap.children[currentSlide].classList.add('active');
    }

    prevBtn.addEventListener('click', function() { goToSlide(currentSlide - 1); });
    nextBtn.addEventListener('click', function() { goToSlide(currentSlide + 1); });
  });



  // ============== Ingredient data (powers .pdp-ingredients-card click → modal) ==============
  (function() {
    const data = {
      hmb: {
        name: 'Calcium HMB',
        dose: '3,000mg / day',
        role: 'Stops the breakdown',
        lead: 'The leading nutritional compound studied for directly suppressing muscle protein breakdown.',
        body: [
          'Your body breaks down muscle every day. After 50, it breaks down faster than it rebuilds. HMB is the leading nutritional compound studied for suppressing that breakdown at the source — even without exercise.',
          'Your body naturally produces HMB from the amino acid leucine in protein — but only in tiny amounts.',
          'To reach the clinical dose of 3,000mg shown to protect against age-related muscle loss, you\'d need around <strong>20 chicken breasts a day.</strong>'
        ],
        stats: [
          { v: '57', u: '%', h: 'Breakdown Suppression', p: 'Reduction in muscle protein breakdown observed in clinical testing environments.' },
          { v: '92', u: '%', h: 'Less Muscle Lost', p: 'Up to ~10× less muscle lost during 10 days of bed rest vs placebo.' },
          { v: '+1.56', u: 'kg', h: 'Lean Muscle Built', p: 'Increase in lean muscle across the arms and legs — verified across 21 randomized controlled trials.' }
        ]
      },
      creatine: {
        name: 'Creatine Monohydrate',
        dose: '5,000mg / day',
        role: 'Fuels what\'s saved',
        lead: 'Proven to increase muscle strength in adults over 55.',
        body: [
          'Creatine fuels the rapid, forceful contractions you rely on without thinking — catching yourself on uneven ground or carrying the shopping from the car. In adults over 65, it nearly quadrupled lean muscle gains compared to training alone.',
          'Less well known: creatine has anti-catabolic activity. Clinical studies show it reduces protein-breakdown markers and dampens the inflammation that drives age-related muscle loss.'
        ],
        stats: [
          { v: '+1.37', u: 'kg', h: 'Lean Muscle Gain', p: 'Lean mass in 721 older adults aged 57–70 across 22 RCTs.' },
          { v: '3', u: '×', h: 'Bone Protection vs placebo', p: 'Creatine + resistance training: 3× less hip bone loss in postmenopausal women.' },
          { v: '14', u: ' days', h: 'Grip Strength', p: 'In just 14 days, grip strength increased in adults aged 64–86.' }
        ]
      },
      vitd: {
        name: 'Vitamin D3',
        dose: '3,000 IU / day',
        role: 'Protects the balance',
        lead: 'The only vitamin proven to reduce the risk of falls.',
        body: [
          '1 in 5 older women in the UK are severely deficient without knowing it. That deficiency quietly weakens the muscle fibres responsible for balance — the ones that fire in the split second between a stumble and a fall.',
          'And it\'s not just balance. The PROVIDE study showed sarcopenic older adults only built muscle when their vitamin D was sufficient too — vitamin D unlocks the response that protein can no longer fully drive on its own.'
        ],
        stats: [
          { v: '39', u: '%', h: 'Fall Prevention', p: 'Reduction in falls with vitamin D and calcium in adults aged 77.' },
          { v: '26', u: '%', h: 'Hip Fracture Risk', p: 'Reduction in hip fracture risk across 19,114 participants.' },
          { v: '5.3', u: '%', h: 'Built vs Lost', p: 'Vitamin D group advantage over placebo across one year (+1.9% vs –3.4%).' }
        ]
      },
      mg: {
        name: 'Magnesium Malate',
        dose: '300mg / day',
        role: 'Muscle function',
        lead: 'Powers every muscle contraction in the body — but absorption drops rapidly after 60.',
        body: [
          'Around 60% of your body\'s magnesium is stored in bones, making it as critical for bones as it is for muscle. When intake falls short, the body draws from that bone reserve to keep blood levels stable for heart and nerve function. The bones quietly weaken over time.'
        ],
        stats: [
          { v: '300', u: '+', h: 'Cellular Processes', p: 'Processes magnesium powers across the body — and without enough, muscles and bones are the first to suffer.' },
          { v: '1,138', u: '', h: 'Grip Strength Link', p: 'Adults studied. Magnesium levels independently linked to grip strength and functional strength.' },
          { v: '↑', u: ' Bone Density', h: 'Skeletal Support', p: 'Higher magnesium intake associated with stronger bones at the hip across 12 studies in adults over 60.' }
        ]
      },
      k2: {
        name: 'Vitamin K2 (MK-7)',
        dose: '180μg / day',
        role: 'Bone health',
        lead: 'We all know calcium matters for bones.',
        body: [
          'But without vitamin K2, your body can\'t direct it to the right place. K2 activates the proteins that deposit calcium into bone — and keep it out of your arteries.',
          'MK-7 is the only form that stays active in the body long enough to work consistently. Other forms peak and disappear within hours.'
        ],
        stats: [
          { v: '62', u: '%', h: 'Fracture Reduction', p: 'Reduction in fracture risk across 6,425 postmenopausal women in 16 RCTs.' },
          { v: 'Over 3', u: ' years', h: 'Density Preservation', p: '180μg of vitamin K2 (MK-7) preserved bone density at spine and hip.' },
          { v: 'Dual', u: ' action', h: 'Build & Protect', p: 'Shown to both increase bone-building markers and reduce bone-breakdown markers.' }
        ]
      },
      vitc: {
        name: 'Vitamin C',
        dose: '200mg / day (250% NRV)',
        role: 'Collagen & bone',
        lead: 'Essential for the collagen that gives bones, cartilage and connective tissue their structure.',
        body: [
          'Without enough, bones become more brittle and recovery from injury slows.',
          'Nearly half of women over 50 don\'t meet recommended levels. Lower intake links directly to higher fracture risk — even at the same bone density.',
          'It\'s also an unsung protector of muscle, shielding cells from the oxidative stress that drives age-related muscle loss.'
        ],
        stats: [
          { v: '69', u: '%', h: 'Hip Fracture Reduction', p: 'Adults in the highest tertile of vitamin C intake had 69% lower hip fracture incidence over 17 years — Framingham Osteoporosis Study, Sahni et al., 2009.' },
          { v: '33', u: '%', h: 'Osteoporosis Risk Reduction', p: 'Lower osteoporosis risk across 106,741 individuals in 38 studies.' },
          { v: '+3.9', u: '%', h: 'Muscle Mass Gained', p: 'Higher muscle mass in women with sufficient vitamin C levels across 13,000+ adults.' }
        ]
      },
      b12folate: {
        name: 'B12 + Folate',
        dose: '50µg vitamin B12 (2,000% NRV) + 400µg folate (200% NRV)',
        role: 'Reduces fracture risk',
        lead: '',
        body: [
          'Here\'s the part most people never hear: bones can be dense and still break. Density is the brick count. If the cement weakens, the wall comes down anyway.',
          'One of the things that quietly weakens the cement is a chemical called homocysteine — a by-product of protein metabolism that builds up with age and interferes with the enzymes that bind collagen together.',
          'In a trial of older adults with elevated homocysteine, B12 and folate supplementation reduced hip fractures by 80%.<br><span style="display:inline-block;margin-top:6px;font-family:\'DM Sans\',sans-serif;font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--subtle-grey);">Sato et al., JAMA, 2005</span>',
          '<em style="display:block;font-family:\'Cormorant Garamond\',serif;font-size:1.25rem;font-style:italic;font-weight:500;color:var(--forest-light);margin-top:18px;">The two vitamins that protect the cement.</em>'
        ],
        stats: []
      }
    };

    const backdrop = document.getElementById('pdpModalBackdrop');
    const modal = document.getElementById('pdpModal');
    const modalBody = document.getElementById('pdpModalBody');
    const modalClose = document.getElementById('pdpModalClose');
    let lastFocused = null;

    function openModal(key, trigger) {
      const d = data[key];
      if (!d) return;

      let html = '';
      html += `<div class="m-role">${d.role}</div>`;
      html += `<div class="m-title" id="pdpModalTitle">${d.name}</div>`;
      html += `<div class="m-dose">${d.dose}</div>`;
      if (d.lead) html += `<div class="m-lead">${d.lead}</div>`;
      d.body.forEach(p => { html += `<div class="m-body">${p}</div>`; });

      if (d.stats && d.stats.length) {
        html += `<div class="m-stats">`;
        d.stats.forEach(s => {
          html += `<div class="m-stat">
            <div class="m-stat-v">${s.v}<span class="u">${s.u}</span></div>
            <div class="m-stat-h">${s.h}</div>
            <div class="m-stat-p">${s.p}</div>
          </div>`;
        });
        html += `</div>`;
      }

      modalBody.innerHTML = html;
      backdrop.classList.add('open');
      modal.classList.add('open');
      document.body.classList.add('modal-open');
      lastFocused = trigger;
      setTimeout(() => modalClose.focus(), 50);
    }

    function closeModal() {
      backdrop.classList.remove('open');
      modal.classList.remove('open');
      document.body.classList.remove('modal-open');
      if (lastFocused) lastFocused.focus();
    }

    // The .2 ingredient cards (.r8-ing-card) carry no data-modal, so map by name
    // to a data key. Matched cards become clickable + keyboard-focusable and open
    // the modal; Calcium has no entry, so it stays non-interactive.
    var nameToKey = {
      'calcium hmb': 'hmb', 'creatine': 'creatine', 'vitamin d3': 'vitd', 'magnesium': 'mg',
      'vitamin k2': 'k2', 'b12 + folate': 'b12folate', 'vitamin c': 'vitc'
    };
    document.querySelectorAll('.r8-ing-card').forEach(function(card) {
      var nameEl = card.querySelector('.r8-ing-name');
      if (!nameEl) return;
      var key = nameToKey[nameEl.textContent.trim().toLowerCase()];
      if (!key || !data[key]) return;
      card.classList.add('r8-ing-card--link');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', nameEl.textContent.trim() + ' - read the science');
      card.addEventListener('click', function() { openModal(key, card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(key, card); }
      });
    });
    modalClose.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });
  })();

  // Synergy — desktop tabs / mobile accordion, from one markup. One item active
  // at a time; item 1 active on load via .is-active. Desktop: clicking a tab
  // switches the shared panel. Mobile: it's an accordion, so clicking the open
  // one closes it.
  (function(){
    const syn = document.getElementById('synergy');
    if (!syn) return;
    const items = Array.from(syn.querySelectorAll('.syn-item'));
    const mq = window.matchMedia('(max-width: 980px)');

    const paintAria = () => {
      items.forEach(item => {
        const btn = item.querySelector('.syn-head');
        if (btn) btn.setAttribute('aria-expanded', String(item.classList.contains('is-active')));
      });
    };

    // Mobile accordion animates max-height on the MAIN THREAD (Safari-safe: a
    // grid-template-rows animation drops the card's rounded clip for a frame on
    // Safari, flashing square corners). Set the exact target height so the timing
    // tracks the content; clear inline heights on desktop so the tab layout,
    // which lays the panel out via grid, is completely unaffected.
    const syncHeights = () => {
      items.forEach(item => {
        const panel = item.querySelector('.syn-panel');
        if (!panel) return;
        if (!mq.matches) { panel.style.maxHeight = ''; return; }
        panel.style.maxHeight = item.classList.contains('is-active')
          ? panel.scrollHeight + 'px'
          : '0px';
      });
    };

    items.forEach(item => {
      const btn = item.querySelector('.syn-head');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const wasActive = item.classList.contains('is-active');
        if (mq.matches) {
          // accordion: allow closing the open one
          items.forEach(c => c.classList.toggle('is-active', !wasActive && c === item));
        } else {
          // tabs: always exactly one active
          items.forEach(c => c.classList.toggle('is-active', c === item));
        }
        syncHeights();
        paintAria();
      });
    });

    if (mq.addEventListener) mq.addEventListener('change', syncHeights);
    window.addEventListener('resize', syncHeights);
    syncHeights();
    paintAria();
  })();

  // Buy panel scroll — AUTO-follow + MANUAL scroll.
  //
  // The panel is pinned to the viewport and is its own scroll container (see CSS:
  // max-height + overflow-y:auto). As the PAGE scrolls, we advance the panel's
  // internal scroll by the same delta, so its content keeps following the page
  // (the familiar auto-scroll animation). Because it's a real scroll container the
  // user can ALSO scroll it MANUALLY — e.g. from the bottom of the page, scroll the
  // panel back up to check the pricing without scrolling the whole page to the top.
  // The two compose cleanly: we ADD the page's scroll delta on top of wherever the
  // panel currently sits (clamped to its own range), so a manual position is kept.
  //
  // Deferred to DOM-ready: this file is loaded as a theme asset, so where the
  // theme puts the <script> decides whether the panel exists yet at parse time.
  // From <head> without defer it would not, and the follow would silently die.
  (function() {
   function initBuyFollow() {
    var panel = document.querySelector('.pdp8-right .buybox');
    if (!panel) return;
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var mq = window.matchMedia('(max-width: 1040px)');
    var lastY = window.scrollY;
    var ticking = false;

    // The panel content is much shorter than the page, so a 1:1 map felt far too
    // fast. FOLLOW_FACTOR advances the panel slower than the page; REVERSE_DELAY
    // absorbs the first chunk of scroll after a direction change so there's a beat
    // before it starts following.
    var FOLLOW_FACTOR = 0.65;
    var REVERSE_DELAY = 260;   // px of page scroll swallowed after reversing
    var FOOTER_FREEZE = 0.30;  // freeze while >30% of the footer is on screen
    var dir = 0;               // last committed scroll direction (1 down, -1 up)
    var absorb = 0;            // px still to absorb before following again

    // How prominent the footer is: the larger of (fraction of the footer visible)
    // and (fraction of the viewport it covers). Robust to any footer height.
    function footerProminence() {
      if (!footer) return 0;
      var r = footer.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var vis = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (vis <= 0) return 0;
      var ofFooter = r.height > 0 ? vis / r.height : 0;
      return Math.max(ofFooter, vis / vh);
    }

    // Freeze = the panel is locked: scripted follow is skipped AND its own overflow
    // scroll is disabled, so a wheel over the panel can't race its content either.
    // scrollTop is held and re-asserted so nothing jumps on unfreeze.
    var frozen = false;
    var heldTop = 0;
    function setFrozen(f) {
      if (f === frozen) return;
      frozen = f;
      if (f) { heldTop = panel.scrollTop; panel.style.overflowY = 'hidden'; }
      else   { panel.style.overflowY = ''; panel.scrollTop = heldTop; }
    }
    // Belt-and-braces: if anything still nudges the panel while frozen, snap it back.
    panel.addEventListener('scroll', function() {
      if (frozen && panel.scrollTop !== heldTop) panel.scrollTop = heldTop;
    }, { passive: true });

    function apply() {
      ticking = false;
      var y = window.scrollY;
      var delta = y - lastY;
      lastY = y;
      if (mq.matches) { setFrozen(false); return; }   // stacked layout: no pinned panel
      var maxScroll = panel.scrollHeight - panel.clientHeight;
      if (maxScroll <= 0) { setFrozen(false); return; }

      // While the footer is on screen, lock the panel. It unlocks the moment the
      // footer drops back under the threshold, then resumes following.
      if (footerProminence() > FOOTER_FREEZE) {
        setFrozen(true);
        dir = delta > 0 ? 1 : -1;                // keep direction current
        absorb = 0;                              // resume immediately once unfrozen
        return;
      }
      setFrozen(false);

      if (Math.abs(delta) < 1) return;           // ignore sub-pixel jitter
      var newDir = delta > 0 ? 1 : -1;
      if (newDir !== dir) {
        var prevDir = dir;
        dir = newDir;
        if (prevDir !== 0) absorb = REVERSE_DELAY;   // only pause on a real reversal
      }
      var mag = Math.abs(delta);
      if (absorb > 0) {                          // hold the panel while absorbing
        var used = Math.min(absorb, mag);
        absorb -= used;
        mag -= used;
        if (mag <= 0) return;
      }

      var next = panel.scrollTop + newDir * mag * FOLLOW_FACTOR;
      if (next < 0) next = 0; else if (next > maxScroll) next = maxScroll;
      panel.scrollTop = next;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }
    function reset(){ lastY = window.scrollY; dir = 0; absorb = 0; }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', reset, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', reset);
    apply();   // set the initial frozen/unfrozen state on load
   }
   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initBuyFollow);
   } else {
     initBuyFollow();
   }
  })();

  // Synergy card carousel (mobile only). The cards are a horizontal scroll-snap
  // track on mobile; these arrows scroll one card at a time and show only where a
  // move is possible: first card -> next only, middle -> both, last -> prev only.
  // Desktop keeps the 3-up grid and the arrows/hint stay hidden (CSS).
  (function() {
    var wrap = document.querySelector('.r8-syn-carousel');
    if (!wrap) return;
    var track = wrap.querySelector('.r8-syn');
    var cards = [].slice.call(wrap.querySelectorAll('.r8-syn-card'));
    var prev = wrap.querySelector('.r8-syn-arrow--prev');
    var next = wrap.querySelector('.r8-syn-arrow--next');
    if (!track || !cards.length || !prev || !next) return;
    var mq = window.matchMedia('(max-width: 860px)');
    var ticking = false;

    function currentIndex() {
      var centre = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cc = cards[i].offsetLeft + cards[i].offsetWidth / 2;
        var d = Math.abs(cc - centre);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function update() {
      ticking = false;
      if (!mq.matches) { prev.style.display = ''; next.style.display = ''; return; }
      var i = currentIndex();
      prev.style.display = i > 0 ? 'flex' : 'none';
      next.style.display = i < cards.length - 1 ? 'flex' : 'none';
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    function go(dir) {
      var t = Math.min(cards.length - 1, Math.max(0, currentIndex() + dir));
      cards[t].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    prev.addEventListener('click', function() { go(-1); });
    next.addEventListener('click', function() { go(1); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  })();

  // Offer section (.r8-tl) number glow - ported behaviour from the old timeline.
  // Each number circle fills plum with a soft ring as it scrolls up past ~70% of
  // the viewport (adds .tl-active to its <li>); scrolling back up removes it.
  (function() {
    var items = [].slice.call(document.querySelectorAll('.r8-tl li'));
    if (!items.length) return;
    var ticking = false;
    function apply() {
      ticking = false;
      var trigger = window.innerHeight * 0.7;
      items.forEach(function(item) {
        var n = item.querySelector('.r8-tl-n');
        if (!n) return;
        var r = n.getBoundingClientRect();
        var centre = r.top + r.height / 2;
        if (centre < trigger) item.classList.add('tl-active');
        else item.classList.remove('tl-active');
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  })();
